import { cpf as CPF } from 'cpf-cnpj-validator';
import * as yup from 'yup';

export const contractingFilterSchema = yup.object().shape({
  searchString: yup
    .string()
    .nullable()
    .default('')
    .optional()
    .test('cpf-or-name', 'Digite um CPF válido ou nome completo', (value) => {
      if (!value || value.trim() === '') return true;

      const trimmed = value.trim();

      const onlyDigits = trimmed.replace(/\D/g, '');
      if (/^\d+$/.test(trimmed) || /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/.test(trimmed)) {
        return CPF.isValid(onlyDigits);
      }
      const words = trimmed.split(/\s+/);
      return words.length >= 2 && words.every((w) => w.length > 1);
    }),
});
